import {
    createSSRApp
} from "vue";
import './router/index.js'
import routeTransition from '@components/route-transition'
// 状态管理
import store from '@/store/pinia'
import { createUnistorage } from "./uni_modules/pinia-plugin-unistorage";
import App from "./App.vue";
import config from "@/config";
import { _wxPaySuccess, _zfbPayFinish, _zfbPaySuccess } from "@utils/appMethods";

// import Vconsole from 'vconsole';
//
// if (config.MODE !== 'production') {
//     new Vconsole();
// }

window.zfbPayFinish = _zfbPayFinish;
window.zfbPaySuccess = _zfbPaySuccess;
window.wxPaySuccess = _wxPaySuccess;

export function createApp() {
    const app = createSSRApp(App);
    // 持久化
    store.use(createUnistorage())
    app.use(store)
    app.use(routeTransition)
    return {
        app,
    };
}
